import merchantAxiosInstance from "../../api/merchantAxiosInstance";
import { getMerchantPaymentStatus } from "../../utills/constants";

export const MERCHANT_PAYMENT_STATUS_REQUEST = "MERCHANT_PAYMENT_STATUS_REQUEST";
export const MERCHANT_PAYMENT_STATUS_SUCCESS = "MERCHANT_PAYMENT_STATUS_SUCCESS";
export const MERCHANT_PAYMENT_STATUS_FAILURE = "MERCHANT_PAYMENT_STATUS_FAILURE";

export const merchantPaymentStatusRequest = () => ({ type: MERCHANT_PAYMENT_STATUS_REQUEST });
export const merchantPaymentStatusSuccess = (data) => ({ type: MERCHANT_PAYMENT_STATUS_SUCCESS, payload: data });
export const merchantPaymentStatusFailure = (error) => ({ type: MERCHANT_PAYMENT_STATUS_FAILURE, payload: error });

export const fetchMerchantPaymentStatus = (payload) => async (dispatch) => {
  const businessCode = payload?.business_code;
  if (!businessCode) {
    dispatch(merchantPaymentStatusFailure("Business code is required"));
    return;
  }
  dispatch(merchantPaymentStatusRequest());
  try {
    const response = await merchantAxiosInstance.post(
      getMerchantPaymentStatus(businessCode),
      payload
    );
    if (!response?.data) throw new Error("No payment status found.");
    dispatch(merchantPaymentStatusSuccess(response.data));
  } catch (error) {
    dispatch(
      merchantPaymentStatusFailure(
        error.response?.data?.message || error.message || "Failed to fetch payment status"
      )
    );
  }
};
